import * as Colours from "../../../../globalStyles/administratorColors";

export const body = {
    paddingTop: "20px",
    paddingRight: "30px"
};

export const columnRight = {
    textAlign: "right"
};

export const controlContainer = {
    display: "flex",
    flexDirection: "row",
    columnGap: "10px",
    alignItems: "center"
};

export const counter = {
    color: "red",
    textAlign: "right"
};

export const exampleHeading = {
    textAlign: "center"
};

export const exampleContainer = {
    border: "4px solid black",
    textAlign: "right",
    padding: "10px"
};

export const hidden = {
    visibility: "hidden"
};

export const unHidden = {
    visibility: "visible"
};

export const cardStyle = {
    backgroundColor: Colours.primary,
    color: "white",
    cursor: "pointer"
};

export const deCardStyle = {
    backgroundColor: "red",
    color: "white",
    cursor: "pointer"
};

export const saleError = {
    color: "red",
    fontWeight: "bold"
};
